import { render, staticRenderFns } from "./ArtikelComponent.vue?vue&type=template&id=4b82e767&"
import script from "./ArtikelComponent.vue?vue&type=script&lang=js&"
export * from "./ArtikelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports